import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Spinner, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { FaEdit } from 'react-icons/fa';
import { adminApi, dsoApi } from '../../services/api';
import Swal from 'sweetalert2';

const CommissionList = () => {
  const navigate = useNavigate();
  const { dsoId } = useParams();
  const [loading, setLoading] = useState(true);
  const [dsoCommissions, setDsoCommissions] = useState({ products: [] });
  const [dsoDetails, setDsoDetails] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Fetch DSO details
        const dsoResponse = await dsoApi.getDsoById(dsoId);
        setDsoDetails(dsoResponse.data);
        
        // Fetch commissions
        const commissionsResponse = await adminApi.getDsoCommissions(dsoId);
        setDsoCommissions(commissionsResponse.data);
      } catch (error) {
        console.error('Error fetching commissions:', error);
        Swal.fire({
          title: 'Error',
          text: 'Failed to fetch DSO commissions',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      } finally {
        setLoading(false);
      }
    };

    if (dsoId) {
      fetchData();
    }
  }, [dsoId]);

  const handleEdit = () => {
    navigate(`/admin/dso/${dsoId}/commissions/edit`);
  };

  // Group products by category
  const groupByCategory = () => {
    const grouped = {};
    
    dsoCommissions.products?.forEach(product => {
      const category = product.category || 'Uncategorized';
      if (!grouped[category]) {
        grouped[category] = [];
      }
      grouped[category].push(product);
    });
    
    return grouped;
  };

  return (
    <Container fluid>
      <Row className="mb-3">
        <Col>
          <Card>
            <Card.Header as="h5" className="d-flex justify-content-between align-items-center">
              {dsoDetails ? `${dsoDetails.name} - Commission Settings` : 'DSO Commission Settings'}
              <Button variant="primary" onClick={handleEdit}>
                <FaEdit className="me-1" /> Edit Commissions
              </Button>
            </Card.Header>
            <Card.Body>
              {loading ? (
                <div className="text-center p-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <>
                  {Object.entries(groupByCategory()).map(([category, products]) => (
                    <div key={category} className="mb-4">
                      <h5 className="border-bottom pb-2">{category}</h5>
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th>Bank</th>
                            <th>Commission Percentage</th>
                            <th>Commission Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {products.map(product => (
                            <tr key={product.product_id}>
                              <td>{product.name}</td>
                              <td>{product.bank || '-'}</td>
                              <td>{product.commission_percentage !== null ? `${product.commission_percentage}%` : '-'}</td>
                              <td>
                                {product.commission_amount !== null 
                                  ? `₹${product.commission_amount.toLocaleString('en-IN')}` 
                                  : '-'
                                }
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ))}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CommissionList;